import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft, Heart, Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { treatments } from "@/lib/treatmentsData";
import { DysfunctionFilters } from "@/components/treatments/DysfunctionFilters";
import { TreatmentCard } from "@/components/treatments/TreatmentCard";

export default function Treatments() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [expanded, setExpanded] = useState(null);
  const [filterDysfunction, setFilterDysfunction] = useState(null);

  const query = search.toLowerCase();
  const filtered = treatments.filter((item) => {
    const text = `${t(`treatments.items.${item.id}.name`)} ${t(`treatments.items.${item.id}.description`)}`.toLowerCase();
    return text.includes(query) && (!filterDysfunction || item.indications.includes(filterDysfunction));
  });

  return (
    <div className="min-h-screen bg-background">
      <div className="border-b border-border bg-card/50 sticky top-0 z-10">
        <div className="max-w-2xl mx-auto px-4 py-4 flex items-center gap-3">
          <Link to="/"><ArrowLeft className="w-5 h-5 text-muted-foreground" /></Link>
          <Heart className="w-5 h-5 text-primary" />
          <h1 className="font-bold text-foreground">{t("treatments.title")}</h1>
        </div>
      </div>

      <div className="max-w-2xl mx-auto px-4 py-6 space-y-5">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
          <Input placeholder={t("treatments.search")} value={search} onChange={(e) => setSearch(e.target.value)} className="pl-9 bg-card border-border" data-testid="treatments-search-input" />
        </div>

        <DysfunctionFilters selected={filterDysfunction} onChange={setFilterDysfunction} />

        <div className="space-y-3">
          {filtered.map((item) => (
            <TreatmentCard key={item.id} item={item} expanded={expanded === item.id} onToggle={() => setExpanded(expanded === item.id ? null : item.id)} />
          ))}
          {filtered.length === 0 && (
            <div className="text-center py-10 text-muted-foreground" data-testid="treatments-empty">{t("treatments.noneFound")}</div>
          )}
        </div>

        <div className="pb-6">
          <Button onClick={() => navigate(-1)} variant="outline" className="w-full border-border text-foreground hover:bg-secondary h-12" data-testid="treatments-back-btn">
            <ArrowLeft className="w-4 h-4 mr-2" />
            {t("common.back")}
          </Button>
        </div>
      </div>
    </div>
  );
}
